// @ts-nocheck
import { GenericContainerCard, GenericWrapper } from './MobileUtilitiesTopMatch';
import { TopDecorColor } from '../../../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/GenericComponentCssMatchCard';
import SpaceInfoMatchComponent from './GenericUtilitiesComponents/SpaceInfoMatchComponent';
import MobileRenderWrestlerWhenOneInSide from './GenericRenderWrestlerWithLogicNumber/MobileRenderWrestlerWhenOneInSide';
import MobileRenderWrestlerWhenTwoInSide from './GenericRenderWrestlerWithLogicNumber/MobileRenderWrestlerWhenTwoInSide';
import MobileRenderWrestlerWhenThreeInSide from './GenericRenderWrestlerWithLogicNumber/MobileRenderWrestlerWhenThreeInSide';
import MobileDefaultTopMatchRender from './MobileDefaultTopMatchRender';
import { SpaceSideWrestlerCssComponent } from './GenericUtilitiesComponents/SpaceSideWrestlerCssComponent';

function MobileHandicapTopMatchRender({ matchInfo }) {

    // Divido matchInfo.wrestlers_by_team in due array uguale.. se dispari, il primo array avra' un elemento in più
    let teamLeft, teamRight
    teamLeft = matchInfo.wrestlers.filter(wrestler => wrestler.team === 1);
    teamRight = matchInfo.wrestlers.filter(wrestler => wrestler.team === 2);


    return (
        // Se il numero di elemento di teamLeft o teamRight è maggiore di 3, renderizzo default
        teamLeft.length > 3 || teamRight.length > 3 ? 
            <MobileDefaultTopMatchRender matchInfo={matchInfo} /> : (

                <GenericContainerCard className='mobile-two-in-side-top-match-render'>   
                    <TopDecorColor className='top-decor-color' height='10px' borderTopLeftRadius='10px' borderTopRightRadius='10px' />
                    <GenericWrapper className='wrapper-triple-top-match'>
                        <SpaceSideWrestlerCssComponent className='space-side-wrestler left'>
                            {/* // A seconda del count del team, renderizzo il giusto ocmponente (da 1 a 3) */}
                            {
                                teamLeft.length === 1 ? 
                                    teamLeft.map((wrestler, index) => (
                                        <MobileRenderWrestlerWhenOneInSide 
                                            wrestler={wrestler} 
                                            side='left'
                                            key={index}
                                        />
                                    ))
                                : 
                                teamLeft.length === 2 ? 
                                    teamLeft.map((wrestler, index) => (
                                        <MobileRenderWrestlerWhenTwoInSide 
                                            wrestler={wrestler} 
                                            side='left'
                                            key={index}
                                        />
                                    ))
                                : 
                                teamLeft.map((wrestler, index) => (
                                    <MobileRenderWrestlerWhenThreeInSide 
                                        wrestler={wrestler} 
                                        side='left'
                                        key={index}
                                    />
                                ))
                            }
                        </SpaceSideWrestlerCssComponent>

                        <SpaceInfoMatchComponent matchInfo={matchInfo} />
                        <SpaceSideWrestlerCssComponent className='space-side-wrestler right'>
                            {
                                teamRight.length === 1 ? 
                                    teamRight.map((wrestler, index) => (
                                        <MobileRenderWrestlerWhenOneInSide 
                                            wrestler={wrestler} 
                                            side='right'
                                            key={index}
                                        />
                                    ))
                                : 
                                teamRight.length === 2 ? 
                                    teamRight.map((wrestler, index) => (
                                        <MobileRenderWrestlerWhenTwoInSide 
                                            wrestler={wrestler} 
                                            side='right'
                                            key={index}
                                        />
                                    ))
                                : 
                                teamRight.map((wrestler, index) => (
                                    <MobileRenderWrestlerWhenThreeInSide 
                                        wrestler={wrestler} 
                                        side='right'
                                        key={index}
                                    />
                                ))
                            }
                        </SpaceSideWrestlerCssComponent>
                    </GenericWrapper>
                </GenericContainerCard>

            )
    )
}

export default MobileHandicapTopMatchRender;